import React from "react";
import { useTranslation } from "react-i18next";
import AppButton from "../../components/ui/AppButton";

const UMAuthorityAddAdminModal = ({ show, mode, form, loading, onModeChange, onFieldChange, onSubmit, onClose }) => {
  const { t } = useTranslation(["staff", "common"]);

  if (!show) return null;

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow">
          <div className="modal-header">
            <h5 className="modal-title">{t("staff:addModal.title")}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="btn-group w-100 mb-3" role="group">
              <AppButton
                type="button"
                variant={mode === "promote" ? "primary" : "outline"}
                onClick={() => onModeChange("promote")}
              >
                {t("staff:addModal.modePromote")}
              </AppButton>
              <AppButton
                type="button"
                variant={mode === "create" ? "primary" : "outline"}
                onClick={() => onModeChange("create")}
              >
                {t("staff:addModal.modeCreate")}
              </AppButton>
            </div>
            <p className="text-muted small">
              {t(mode === "promote" ? "staff:addModal.promoteHint" : "staff:addModal.createHint")}
            </p>

            <form onSubmit={onSubmit}>
              <div className="row g-3">
                {mode === "create" && (
                  <>
                    <div className="col-md-6">
                      <label className="form-label">{t("staff:addModal.firstName")}</label>
                      <input
                        className="form-control"
                        value={form.firstName}
                        onChange={(e) => onFieldChange("firstName", e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">{t("staff:addModal.lastName")}</label>
                      <input
                        className="form-control"
                        value={form.lastName}
                        onChange={(e) => onFieldChange("lastName", e.target.value)}
                        required
                      />
                    </div>
                  </>
                )}
                <div className="col-12">
                  <label className="form-label">{t("staff:addModal.email")}</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder={t("staff:addModal.emailPlaceholder")}
                    value={form.email}
                    onChange={(e) => onFieldChange("email", e.target.value)}
                    required
                  />
                </div>
                {mode === "create" && (
                  <>
                    <div className="col-12">
                      <label className="form-label">{t("staff:addModal.password")}</label>
                      <input
                        type="password"
                        className="form-control"
                        value={form.password}
                        onChange={(e) => onFieldChange("password", e.target.value)}
                        required
                        minLength={8}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label">{t("staff:addModal.phoneNumber")}</label>
                      <input
                        className="form-control"
                        value={form.phoneNumber}
                        onChange={(e) => onFieldChange("phoneNumber", e.target.value)}
                      />
                    </div>
                  </>
                )}
              </div>

              <div className="modal-footer border-0 px-0 pb-0">
                <AppButton variant="secondary" type="button" onClick={onClose}>
                  {t("common:buttons.cancel")}
                </AppButton>
                <AppButton variant="primary" type="submit" disabled={loading}>
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" role="status"></span>
                  ) : mode === "promote" ? (
                    t("staff:addModal.submitPromote")
                  ) : (
                    t("staff:addModal.submitCreate")
                  )}
                </AppButton>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UMAuthorityAddAdminModal;
